import * as tslib_1 from "tslib";
import './input.less';
import classnames from 'classnames';
import m from 'mithril';
import { Component } from '../component';
var Input = /** @class */ (function (_super) {
    tslib_1.__extends(Input, _super);
    function Input() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.className = _this.attrs.className || (_this.attrs.unstyled && 'input') || 'input-front';
        _this.inputDom = null;
        return _this;
    }
    Input.prototype.view = function () {
        var _this = this;
        var _a = this.attrs, value = _a.value, onchange = _a.onchange, label = _a.label, name = _a.name, modifier = _a.modifier, onfocus = _a.onfocus, _b = _a.type, type = _b === void 0 ? 'text' : _b, required = _a.required, disabled = _a.disabled, placeholder = _a.placeholder;
        return m("." + this.className, { class: classnames([modifier, value && 'has-value']) }, [
            m("input." + this.className + "-input", {
                type: type,
                required: required,
                disabled: disabled,
                name: name,
                value: value,
                placeholder: placeholder,
                onfocus: onfocus,
                oncreate: function (vnode) { return (_this.inputDom = vnode.dom); },
                oninput: onchange && (function (e) { return onchange(e.target.value); }),
                onchange: onchange && (function (e) { return onchange(e.target.value); })
            }),
            label && m("label." + this.className + "-label", label)
        ]);
    };
    return Input;
}(Component));
export { Input };
